<script setup>
// §8.5 BucketPicker — DEPENDENT on ClientPicker. Client → Bucket is the
// canonical hierarchy; the bucket list is scoped to the chosen client and the
// control is disabled (with a reason) until a client is picked. "bucket" is
// firm-configurable — matter / project / shift (§9); the label is passed in,
// never hard-coded.
import { computed, watch } from 'vue'
import LComboField from './ComboField.vue'

const props = defineProps({
	// buckets keyed by client value: { [clientValue]: [{ value, label, meta }] }
	bucketsByClient: { type: Object, default: () => ({}) },
	client: { type: [String, Number], default: null }, // the selected client value
	label: { type: String, default: 'Bucket' }, // firm term
})
const model = defineModel({ default: null })

const items = computed(() => (props.client ? props.bucketsByClient[props.client] || [] : []))

// Reset the bucket if the client changes out from under it.
watch(() => props.client, () => { model.value = null })
</script>

<template>
	<LComboField 
		v-model="model" 
		:label="label" 
		:items="items" 
		:disabled="!client" 
		disabled-hint="Pick a client first"
		:placeholder="`Select a ${label.toLowerCase()}…`" 
		:search-placeholder="`Search ${label.toLowerCase()}s…`" />
</template>
